<template>
  <div>
    <main id="page_sub">
      <form id="noticeForm" @submit.prevent="writeNoticeForm">
        <section id="page_contents">
          <h5>공지사항</h5>
          <div id="notice">
            <table cellspacing="0">
              <caption>
                공지사항게시판
              </caption>
              <tr>
                <th class="tleft">제목</th>
                <th colspan="3">
                  <kendo-maskedtextbox
                          ref="titleRef"
                          name="title"
                          class="userInput"
                          v-bind:style="'width: 100%;'"
                          maxlength="1000"
                  >
                  </kendo-maskedtextbox>
                </th>
              </tr>
              <tr>
                <td class="tleft">구분</td>
                <td colspan="3" class="tleft">
                  <div class="k_area01">
                    <kendo-dropdownlist :data-source="[
                                            { text: '일반공지', value: '01' },
                                            { text: '주요공지', value: '02' },
                                            { text: '긴급공지', value: '03' }
                                            ]"
                                        :data-text-field="'text'"
                                        :data-value-field="'value'"
                                        :option-label="'공지 선택'"
                                        v-bind:style="'width: 100%;'"
                                        name="brdGbn"
                                        ref="brdGbnRef"
                    >
                    </kendo-dropdownlist>
                  </div>
                  <div class="k_area02">
                    <label class="myCheckbox">
                      <input type="checkbox" name="impLevel" ref="impLevelRef" value="01" v-model="impLevel"/>
                      <span></span>
                      해당 글을 상단에 고정
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>작성자</td>
                <td class="tleft">
                  <div>{{this.$store.state.userStore.userInfo.userId}}</div>
                </td>
                <td class="tleft">공지기간</td>
                <td class="tperi">
                  <kendo-daterangepicker
                          ref="noticeDateRangeRef"
                          :min="brdFrom"
                          :max="brdTo"
                          :format="'yyyy/MM/dd'"
                          :range="currentRange"
                  >
                  </kendo-daterangepicker>
                </td>
              </tr>

            </table>
            <!--------//쓰기영역 및 에디터 /kendo-ui form활용 -------->
          </div>
          <kendo-editor :resizable-content="true"
                        :resizable-toolbar="false"
                        ref="contentsRef"
                        name="contents"
                        :value="contents"
                        class="tleft"
                        style="height:380px"
                        rows="10"
                        :image-browser="imageBrowser"
                        :file-browser="fileBrowser"
                        :paste-cleanup="pasteCleanup"
          >
          </kendo-editor>
          <div>

              <file-upload v-bind:file="uploads" @child="bindingFiles"></file-upload>

          </div>

          <!--- 버튼영역/취소버튼을누르면목록으로갑니다/버튼도 켄도사용 --->
          <div class="btn_area mt20">
            <kendo-button class="k-primary k-button k-big" @click.prevent="writeNoticeForm" v-if="isAdminUser === true && brdNo === null">
              등록
            </kendo-button>
            <kendo-button class="k-primary k-button k-big" @click.prevent="writeNoticeForm" v-else-if="isAdminUser === true && brdNo !== null">
              수정
            </kendo-button>
            <router-link :to="{ name: 'Notice' }" tag="button" class="k-button k-big" v-if="isAdminUser === true">
              취소
            </router-link>
          </div>
          <!--- //버튼영역 --->
        </section>
      </form>
    </main>
  </div>

</template>

<script>
  import EtnersDateTimeUtil from '../../../src/common/etners.datetime.util'
  import FileUpload from "../../components/FileUpload";
  import EtnersCommonUtil from '../../../src/common/etners.common.util'


  export default {
    name: 'NoticeForm',
    components: {FileUpload},
     mounted () {
      //수정
      const vue = this
      if (this.$route.query.brdNo !== undefined) {
        let params = {
          loginUserToken: sessionStorage.getItem('lutk'),
          brdNo         : this.brdNo,
        }
        this.$store.dispatch('FETCH_NOTICE_DETAIL', params).then(data => {
          console.log(data)
          vue.dataItems = data.resultData
          vue.$refs.titleRef.kendoWidget().value(vue.dataItems.title)
          vue.$refs.brdGbnRef.kendoWidget().value(vue.dataItems.brdGbn)
          vue.$refs.impLevelRef.value = vue.dataItems.impLevel

          vue.$refs.noticeDateRangeRef.kendoWidget().range({start:EtnersDateTimeUtil.lookupDateYYYYMMDD(
            EtnersCommonUtil.extractOnlyNumbers(vue.dataItems.brdFrom)) , end: EtnersDateTimeUtil.lookupDateYYYYMMDD(
            EtnersCommonUtil.extractOnlyNumbers(vue.dataItems.brdTo))})

          if (vue.dataItems.impLevel == '01') {
            vue.impLevel = true
          } else {
            vue.impLevel = false
          }
          vue.$refs.contentsRef.kendoWidget().body.innerHTML = vue.dataItems.contents
          // editor.body.innerHTML=vue.dataItems.contents>{{file.orgFileNm}}({{file.fileSize}}
          const files = vue.dataItems.boardFiles
          vue.fileId = files[0].fileId

          files.forEach(function (v) {
            const fileDetail = new File([],v.orgFileNm,{type:v.fileType,lastModified:new Date(),size:parseInt(v.fileSize)})
            const fileInfo = {'name':v.orgFileNm,'size':v.fileSize,'extension':v.fileExt,'seq':v.seqNo, 'fileId':v.fileId}
            vue.uploads.push(fileInfo)
            })
        })

      }

    },
    computed: {},
    watch   : {},
    methods : {
      writeNoticeForm: function () {
        const vue = this
        let validation = false

        if (vue.$refs.titleRef.kendoWidget().value() == '') {
          kendo.alert('제목을 필수 입니다')
          return validation
        }

        if (vue.$refs.brdGbnRef.kendoWidget().value() == '') {
          kendo.alert('공지구분은 필수 입니다')
          return validation
        }

        if (
          vue.$refs.noticeDateRangeRef.kendoWidget().range().start == '') {
          kendo.alert('공지기간 시작일은 필수 입니다')
          return validation
        }

        if (
          vue.$refs.noticeDateRangeRef.kendoWidget().range().end == '') {
          kendo.alert('공지기간 마감일은 필수 입니다')
          return validation
        }
        validation = true

        if (validation) {

          kendo.confirm('공지사항을 등록 하시겠습니까?').done(function () {
            let params = {
              loginUserToken: sessionStorage.getItem('lutk'),
              title         : vue.$refs.titleRef.kendoWidget().value(),
              brdGbn        : vue.$refs.brdGbnRef.kendoWidget().value(),
              impLevel      : vue.$refs.impLevelRef.value,
              brdFrom       : EtnersDateTimeUtil.dateToYYYYMMDD(
                vue.$refs.noticeDateRangeRef.kendoWidget().range().start),
              brdTo         : EtnersDateTimeUtil.dateToYYYYMMDD(
                vue.$refs.noticeDateRangeRef.kendoWidget().range().end),
              contents      : vue.$refs.contentsRef.kendoWidget().value(),
              solCd : '0000',
              existSeqs:[],
              existFileId :'',
              brdNo : vue.brdNo
            }


            const paramData = new FormData()
            vue.uploads.forEach(function(v){
              if(v.rawFile !== undefined) {
                paramData.append("file", v.rawFile)
              }
              if(v.seq !== undefined){
                params.existSeqs.push(v.seq)
                params.existFileId = v.fileId
              }
            })

            paramData.append("noticeParams",new Blob([JSON.stringify(params)], {
              type: "application/json"
            }))


            vue.$store.dispatch('FETCH_NOTICE_WRITE', paramData).then(response => {
              if (response.resultStatus.messageCode === '2000') {
                kendo.alert('공지사항이 등록 되었습니다.')
                vue.$router.push({ name: 'Notice' })
              }
            })
          }).fail(function () {
          })
        }
      },
      bindingFiles(files){
        const vue = this
        files.forEach(function (fileInfo) {
          vue.uploads.push(fileInfo)
        })

      }
    },
    data () {
      let loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
      let isAdminUser = false

      if (loginUserData.authCd === '99999') {
        isAdminUser = true
      }

      let brdNo = null

      if (this.$route.query.brdNo === undefined) {
        brdNo = null
      } else {
        brdNo = this.$route.query.brdNo
      }

      return {
        isAdminUser : isAdminUser,
        brdNo       : brdNo,
        title       : null,
        brdGbn      : null,
        impLevel    : false,
        brdFrom     : new Date(),
        brdTo       : new Date(new Date().setDate(new Date().getDate() + 500)),
        currentRange: { start: new Date(), end: new Date(new Date().setDate(new Date().getDate() + 500)) },
        contents    : null,

        imageBrowser: {
          transport: {
            read        : 'https://demos.telerik.com/kendo-ui/service/ImageBrowser/Read',
            destroy     : {
              url : 'https://demos.telerik.com/kendo-ui/service/ImageBrowser/Destroy',
              type: 'POST',
            },
            create      : {
              url : 'https://demos.telerik.com/kendo-ui/service/ImageBrowser/Create',
              type: 'POST',
            },
            thumbnailUrl: 'https://demos.telerik.com/kendo-ui/service/ImageBrowser/Thumbnail',
            uploadUrl   : 'https://demos.telerik.com/kendo-ui/service/ImageBrowser/Upload',
            imageUrl    : 'https://demos.telerik.com/kendo-ui/service/ImageBrowser/Image?path={0}',
          },
        },
        fileBrowser : {
          transport: {
            read     : 'https://demos.telerik.com/kendo-ui/service/FileBrowser/Read',
            destroy  : {
              url : 'https://demos.telerik.com/kendo-ui/service/FileBrowser/Destroy',
              type: 'POST',
            },
            create   : {
              url : 'https://demos.telerik.com/kendo-ui/service/FileBrowser/Create',
              type: 'POST',
            },
            uploadUrl: 'https://demos.telerik.com/kendo-ui/service/FileBrowser/Upload',
            fileUrl  : 'https://demos.telerik.com/kendo-ui/service/FileBrowser/File?fileName={0}',
          },
        },
        pasteCleanup: {
          all            : false,
          css            : false,
          keepNewLines   : false,
          msAllFormatting: false,
          msConvertLists : true,
          msTags         : true,
          none           : false,
          span           : false,
        },
        uploads : [],
        fileId : ''
      }
    }
    ,

  }
</script>

<style scoped>

</style>
